import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { RestApiResponse } from "@/types/common.api";

type GetReservedGenerativeCreditsResponse = {
  credits: number;
};

export const generativeCreditApi = createApi({
  reducerPath: "generativeCredit",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/credit/generative-credit",
  }),
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: true,
  tagTypes: ["GenerativeCredit"],

  endpoints: (build) => ({
    getReservedGenerativeCredits: build.query<
      GetReservedGenerativeCreditsResponse,
      void
    >({
      query: () => "/reserved",
      transformResponse: (
        res: RestApiResponse<GetReservedGenerativeCreditsResponse>,
      ) => {
        if (!res.success || !res.data) {
          throw new Error("Failed to fetch reserved generative credits");
        }

        return res.data;
      },
      providesTags: ["GenerativeCredit"],
    }),
  }),
});
